/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const publicChallengeTranslationItemSchema = z.object({
  lang: z.string(),
  title: z.string().nullable(),
  definition: z.string(),
  definitionSimple: z.string().nullable(),
  examples: z.string().nullable(),
  usageNotes: z.string().nullable(),
  verified: z.number(),
  generatedAt: z.string().nullable(),
});

export type IPublicChallengeTranslationItem = z.infer<typeof publicChallengeTranslationItemSchema>;

export const listPublicChallengeTranslationsBySlugV1ResponseDataSchema = z.array(
  publicChallengeTranslationItemSchema,
);

export type IListPublicChallengeTranslationsBySlugV1ResponseData = z.infer<
  typeof listPublicChallengeTranslationsBySlugV1ResponseDataSchema
>;

export const listPublicChallengeTranslationsBySlugV1ResponseSchema = createApiResponseSchema(
  listPublicChallengeTranslationsBySlugV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IListPublicChallengeTranslationsBySlugV1ResponseData>>;

export type IListPublicChallengeTranslationsBySlugV1Response =
  IAPI<IListPublicChallengeTranslationsBySlugV1ResponseData>;
